import { DateTimeFormatOptions } from 'luxon'

/**
 * Like Luxon's DATETIME_MED_WITH_WEEKDAY but includes the year.
 * Used for event date headers and pet marker timestamps.
 */
export const DATETIME_MED_WITH_WEEKDAY: DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
}
